import { render, staticRenderFns } from "./ProjectDeleteModalComponent.vue?vue&type=template&id=645f6602&"
import script from "./ProjectDeleteModalComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectDeleteModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports